import { useQuery } from '@tanstack/react-query'

import { useProjectInfo } from 'hooks/useProjectInfo/useProjectInfo'

import { queryKeys } from '../../queryKeys'
import { useSpringClient } from '../useSpringClient/useSpringClient'
import { ListSchemaViewsResponse } from './types'

export const useSchemaViews = (warehouse: string, schemaName: string) => {
  const { projectId, environmentId } = useProjectInfo()
  const client = useSpringClient()

  return useQuery(
    [projectId, environmentId, queryKeys.listSchemaViews, schemaName],
    async () => {
      const { data } = await client.get<ListSchemaViewsResponse>(
        `projects/${projectId}/environments/${environmentId}/warehouse/${warehouse}/schemas/${schemaName}/views`
      )
      return data.results
    },
    {
      enabled: !!warehouse
    }
  )
}
